export function getExpertApprovalStatus(user) {
  if (user?.role !== "expert") return null;
  return user.expert_profile?.approval_status || "draft";
}

export function hasApprovedExpertAccess(user) {
  return (
    user?.role === "expert" &&
    user.expert_profile?.approved === true &&
    getExpertApprovalStatus(user) === "approved"
  );
}

export function getExpertAccessPath(user) {
  if (hasApprovedExpertAccess(user)) return "/expert";
  return getExpertApprovalStatus(user) === "pending"
    ? "/expert/afventer-godkendelse"
    : "/expert/onboarding";
}
